/**
 * AI 模块生成接口：Pollo 多模型
 * 提交 -> taskId；轮询 GET /generation/{taskId}/status 直至 succeed/failed（各模型通用）
 */
import { getAiClient } from './client'
import { getModelPath } from '@/config/ai-providers'
import { buildBody, parsePolloStatus } from './adapters/video/pollo/index'

var POLL_INTERVAL = 3000
var POLL_TIMEOUT = 10 * 60 * 1000

/**
 * 提交 Pollo 模型任务（按 modelId 选 path + body 构建）
 * @param {string} modelId - 如 'seedance-1-5-pro', 'wan-2-2-plus'
 * @param {Object} params - 统一前端参数
 * @returns {Promise<{ taskId: string, status?: string }>} status: waiting | succeed | failed | processing
 */
export function submitPolloModel(modelId, params) {
  var mapping = getModelPath(modelId)
  if (!mapping) return Promise.reject(new Error('Model not configured: ' + modelId))
  var client = getAiClient(mapping.providerId)
  var path = mapping.path
  var body = buildBody(modelId, params)
  return client.post(path, body).then(function (res) {
    var taskId = (res && (res.taskId || res.task_id)) || (res && res.data && (res.data.taskId || res.data.task_id))
    if (!taskId) return Promise.reject(new Error('未返回 taskId'))
    var st = (res && res.status) || (res && res.data && res.data.status)
    return { taskId: taskId, status: st }
  })
}

/**
 * 轮询 Pollo 任务状态（各模型通用）
 * 任务提交拿到 taskId 后调用，轮询 GET /generation/{taskId}/status 直至 status 为 completed 或 failed
 */
export function pollPolloStatus(taskId, callback, interval) {
  var pollInterval = interval || POLL_INTERVAL
  var deadline = Date.now() + POLL_TIMEOUT
  var pollTimer = null
  var stopped = false
  var client = getAiClient('pollo')
  var path = '/generation/' + encodeURIComponent(taskId) + '/status'

  function stop() {
    stopped = true
    if (pollTimer) {
      clearTimeout(pollTimer)
      pollTimer = null
    }
  }

  function poll() {
    if (stopped) return
    client.get(path)
      .then(function (res) {
        if (stopped) return
        var parsed = parsePolloStatus(res)
        if (typeof callback === 'function') callback(null, parsed)
        if (parsed.status === 'completed' || parsed.status === 'failed') { // completed 对应接口的 succeed
          stop()
          return
        }
        if (Date.now() > deadline) {
          if (typeof callback === 'function') callback(new Error('轮询超时'), null)
          stop()
          return
        }
        pollTimer = setTimeout(poll, pollInterval)
      })
      .catch(function (err) {
        if (stopped) return
        if (typeof callback === 'function') callback(err, null)
        stop()
      })
  }

  poll()
  return { stop: stop }
}
